import { useFormikContext } from "formik";
import { PhoneInput } from "@/core/components/phone-input";
import { SignupSourceSelector } from "@/core/components/signup-source-selector";
import { Button } from "@volca/ui/components/ui/button";
import { FormikCheckboxWithLabel } from "@volca/ui/components/ui/checkbox-with-label";
import { FormInput } from "@volca/ui/components/ui/form-input";
import { Separator } from "@volca/ui/components/ui/separator";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { AddReferralFormValues } from "./schema";

interface NewAdvocateFieldsProps {
  businessId?: string;
}

export const NewAdvocateFields = ({ businessId }: NewAdvocateFieldsProps) => {
  const { values, getFieldProps, setFieldValue } =
    useFormikContext<AddReferralFormValues>();

  return (
    <Stack className="w-full" align="start" gap={6}>
      <Separator />
      <Stack
        className="w-full"
        gap={4}
        direction="row"
        justify="between"
        align="center"
      >
        <Text variant="title">New advocate</Text>
        <Button
          type="button"
          variant="link"
          size="xs"
          className="h-auto p-0"
          onClick={() => setFieldValue("isAddingNewAdvocate", false)}
        >
          Cancel
        </Button>
      </Stack>
      <PhoneInput
        value={values.advocate_phone}
        onChange={(value) => setFieldValue("advocate_phone", value)}
        label="Advocate phone number"
        fullWidth
        required
      />
      <FormInput
        label="Advocate name"
        {...getFieldProps("advocate_name")}
        fullWidth
      />
      <SignupSourceSelector
        businessId={businessId}
        selectedSourceId={values.signup_source_id}
        selectedSourceType={values.signup_source_type}
        onSourceChange={(sourceId, sourceType) => {
          void setFieldValue("signup_source_id", sourceId);
          void setFieldValue("signup_source_type", sourceType);
        }}
      />
      <FormikCheckboxWithLabel
        id="onboard"
        label="Send advocate program sign-up SMS"
        checked={values.onboard}
        onCheckedChange={(checked) => setFieldValue("onboard", !!checked)}
      />
      <Separator />
    </Stack>
  );
};
